import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@bonusly/design-system';

interface Props {
	isOpen: boolean;
	onConfirm: VoidFunction;
	onClose: VoidFunction;
	heading?: string;
	body?: string;
	cancelText?: string;
	confirmText?: string;
}

export const GiveModalConfirmDelete: FC<Props> = ({ isOpen, onClose, onConfirm, heading, body, cancelText, confirmText }) => {
	const { t } = useTranslation('video');
	const modalHeading = heading ?? t('delete_modal.heading');
	const modalBody = body ?? t('delete_modal.body');
	const modalCancelText = cancelText ?? t('delete_modal.actions.cancel');
	const modalConfirmText = confirmText ?? t('delete_modal.actions.delete');

	return (
		<Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside" size="sm">
			<ModalOverlay onClick={onClose} />
			<ModalContent>
				<ModalHeader border="none">{modalHeading}</ModalHeader>
				<ModalCloseButton borderRadius="full" top={4} />
				<ModalBody>
					<Text>{modalBody}</Text>
				</ModalBody>

				<ModalFooter px={5} pb={5}>
					<Button data-testid="delete-cancel" colorScheme="secondary" mr={4} variant="link" onClick={onClose}>
						{modalCancelText}
					</Button>
					<Button data-testid="delete-confirm" colorScheme="danger" variant="solid" onClick={onConfirm}>
						{modalConfirmText}
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};
